// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum ChargeVehicleRegistrationChangeRejectionReason {
  WarningBypassingForbidden = "WARNING_BYPASSING_FORBIDDEN",
}
export default ChargeVehicleRegistrationChangeRejectionReason;
